"use client";

import Head from "next/head";
import { useRouter } from "next/router";

export default function LayoutHead({title, metadata, link, schemaTag}) {
  const router = useRouter();
  
  return (
    <>
      {router.isReady && <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{title}</title>
        {metadata?.map((data, i) => <meta key={`meta_${i}`} {...data} />)}
        {link?.map((data, i) => <link key={`link_${i}`} {...data} />)}
        {schemaTag?.map((tag, i) => <script key={`tag_${i}`} type="application/ld+json">{JSON.stringify(tag)}</script>)}
      </Head>}
    </>
  );
}